import { useEffect } from 'react';
import { PageHitCountApi } from '../../shared/Helper';
import { useLocation } from 'react-use';
import ProjectCards from '../../components/cards/ProjectCards';
import Banners from '../../components/elements/Banners';
import Stats from '../../components/elements/Stats';
import TabCards from '../../components/elements/TabCards';
import './home.css';

const Home = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <div className="flex flex-col">
      <div className=" ">
        <Banners />
      </div>
      <div className="">
        <TabCards />
      </div>

      <div className="">
        <ProjectCards />
      </div>

      {/* <div className="relative z-10">
    <HeadingSection headingStyle={'text-green-900'} title="Brands" />
    <ProjectSliders />
  </div> */}

      <div className="">
        <Stats />
      </div>
    </div>
  );
};

export default Home;
